(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ng-subscription-catalog"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots=document.querySelectorAll('[data-ngc-sub-builder]');
  roots.forEach(function(root){
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var currency=root.dataset.currency||'USD';
    var cartUrl=root.dataset.cartUrl||'/cart';
    var cartAddUrl=root.dataset.cartAddUrl||'/cart/add.js';
    var cards=Array.from(root.querySelectorAll('[data-ngc-card]'));
    var tabs=Array.from(root.querySelectorAll('[data-ngc-tab]'));
    var frequencyInputs=Array.from(root.querySelectorAll('[data-ngc-frequency] input'));
    var itemsNode=root.querySelector('[data-ngc-items]');
    var emptyNode=root.querySelector('[data-ngc-empty]');
    var countNode=root.querySelector('[data-ngc-count]');
    var subtotalNode=root.querySelector('[data-ngc-subtotal]');
    var savingsNode=root.querySelector('[data-ngc-savings]');
    var totalNode=root.querySelector('[data-ngc-total]');
    var boxFrequencyNode=root.querySelector('[data-ngc-box-frequency]');
    var submit=root.querySelector('[data-ngc-submit]');
    var error=root.querySelector('[data-ngc-error]');
    var box=root.querySelector('[data-ngc-box]');
    var mobileTracker=root.querySelector('[data-ngc-mobile-tracker]');
    var mobileCount=root.querySelector('[data-ngc-mobile-count]');
    var mobileRegular=root.querySelector('[data-ngc-mobile-regular]');
    var mobileTotal=root.querySelector('[data-ngc-mobile-total]');
    var mobileReview=root.querySelector('[data-ngc-mobile-review]');
    var selections=new Map();
    var dataByKey=new Map();

    function money(cents){
      return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format((Number(cents)||0)/100);
    }
    function frequencyLabel(weeks){return 'Every '+weeks+' weeks';}
    function parseData(card){
      var node=card.querySelector('[data-ngc-product-data]');
      if(!node)return null;
      try{
        var data=JSON.parse(node.textContent);
        dataByKey.set(card.dataset.key,data);
        return data;
      }catch(e){return null;}
    }
    function getFrequency(){
      var checked=frequencyInputs.find(function(input){return input.checked;});
      return checked?checked.value:'2';
    }
    function allocationFor(variant,weeks){
      if(!variant)return null;
      return (variant.allocations||[]).find(function(allocation){
        return String(allocation.name||'').toLowerCase().indexOf(weeks+' week')!==-1;
      })||null;
    }
    function same(a,b){return String(a||'').trim().toLowerCase().replace(/\s+/g,'')===String(b||'').trim().toLowerCase().replace(/\s+/g,'');}
    function resolveVariant(card,data){
      if(!data)return null;
      var desired={};
      Array.from(card.querySelectorAll('[data-ngc-option]')).forEach(function(control){
        desired[Number(control.dataset.ngcOption)]=control.value;
      });
      var sizeIndex=(data.options||[]).findIndex(function(option){return String(option.name||'').toLowerCase()==='size';});
      if(data.lockedSize&&sizeIndex>=0)desired[sizeIndex]=data.lockedSize;
      var variant=(data.variants||[]).find(function(candidate){
        if(!candidate.available)return false;
        return Object.keys(desired).every(function(index){return same(candidate.options[Number(index)],desired[index]);});
      });
      if(!variant&&!data.lockedSize)variant=(data.variants||[]).find(function(candidate){return candidate.available;});
      return variant||null;
    }
    function optionSummary(data,variant){
      if(!data||!variant)return '';
      var parts=[];
      (data.options||[]).forEach(function(option,index){
        var name=String(option.name||'');
        var value=variant.options[index];
        if(!value||value==='Default Title')return;
        if(data.lockedSize&&name.toLowerCase()==='size')return;
        parts.push(value);
      });
      if(data.lockedSize)parts.push(data.lockedSize);
      return parts.join(' · ');
    }
    function updateCard(card){
      var data=dataByKey.get(card.dataset.key)||parseData(card);
      if(!data)return;
      var variant=resolveVariant(card,data);
      var allocation=allocationFor(variant,getFrequency());
      var priceNode=card.querySelector('[data-ngc-price]');
      var regularPriceNode=card.querySelector('[data-ngc-regular-price]');
      var deliveryNode=card.querySelector('[data-ngc-delivery]');
      var add=card.querySelector('[data-ngc-add]');
      if(deliveryNode)deliveryNode.textContent=frequencyLabel(getFrequency());
      if(regularPriceNode)regularPriceNode.textContent=variant?money(variant.price):'—';
      if(priceNode)priceNode.textContent=allocation?money(allocation.price):(variant?money(variant.price):'—');
      if(regularPriceNode)regularPriceNode.hidden=!allocation||!variant||Number(allocation.price)>=Number(variant.price);
      if(add)add.disabled=!variant||!allocation;
      card._ngcCurrent={data:data,variant:variant,allocation:allocation};
    }
    function updateAllCards(){cards.forEach(updateCard);}
    function syncSelectionsToFrequency(){
      var weeks=getFrequency();
      Array.from(selections.entries()).forEach(function(entry){
        var key=entry[0],item=entry[1];
        var data=dataByKey.get(item.dataKey);
        if(!data)return;
        var variant=(data.variants||[]).find(function(candidate){return String(candidate.id)===String(item.variantId);});
        var allocation=allocationFor(variant,weeks);
        if(!allocation){selections.delete(key);return;}
        item.sellingPlanId=allocation.sellingPlanId;
        item.price=Number(allocation.price)||0;
        item.compareAtPrice=Number(allocation.compareAtPrice)||item.price;
        item.frequency=weeks;
      });
    }
    function escapeHtml(value){
      return String(value||'').replace(/[&<>"']/g,function(char){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char];});
    }
    function renderBox(){
      var values=Array.from(selections.values());
      var itemCount=values.reduce(function(sum,item){return sum+item.quantity;},0);
      var subtotal=values.reduce(function(sum,item){return sum+item.price*item.quantity;},0);
      var compare=values.reduce(function(sum,item){return sum+item.compareAtPrice*item.quantity;},0);
      var savings=Math.max(0,compare-subtotal);
      if(boxFrequencyNode)boxFrequencyNode.textContent=frequencyLabel(getFrequency());
      if(countNode)countNode.textContent=itemCount+' '+(itemCount===1?'item':'items');
      if(subtotalNode)subtotalNode.textContent=money(compare||subtotal);
      if(savingsNode)savingsNode.textContent=savings>0?'−'+money(savings):'—';
      if(totalNode)totalNode.textContent=money(subtotal);
      if(mobileCount)mobileCount.textContent=itemCount+' '+(itemCount===1?'item':'items');
      if(mobileRegular){
        mobileRegular.textContent=money(compare||subtotal);
        mobileRegular.hidden=savings<=0;
      }
      if(mobileTotal)mobileTotal.textContent=money(subtotal);
      if(mobileTracker)mobileTracker.hidden=values.length===0;
      root.classList.toggle('ngc-sub-builder--has-mobile-tracker',values.length>0);
      if(emptyNode)emptyNode.hidden=values.length>0;
      if(submit)submit.disabled=values.length===0;
      if(!itemsNode)return;
      itemsNode.innerHTML=values.map(function(item){
        var image=item.image?'<img src="'+escapeHtml(item.image)+'" alt="">':'<span></span>';
        return '<div class="ngc-sub-box__item" data-summary-key="'+escapeHtml(item.key)+'">'+image+
          '<div><h4>'+escapeHtml(item.title)+'</h4><p>'+escapeHtml(item.options)+(item.options?' · ':'')+escapeHtml(frequencyLabel(item.frequency))+'</p></div>'+
          '<div class="ngc-sub-box__qty"><button type="button" data-qty-action="minus" aria-label="Decrease '+escapeHtml(item.title)+'">−</button><span>'+item.quantity+'</span><button type="button" data-qty-action="plus" aria-label="Increase '+escapeHtml(item.title)+'">+</button></div></div>';
      }).join('');
    }

    cards.forEach(function(card){
      parseData(card);
      Array.from(card.querySelectorAll('[data-ngc-option]')).forEach(function(control){
        control.addEventListener('change',function(){updateCard(card);});
      });
      var add=card.querySelector('[data-ngc-add]');
      if(add)add.addEventListener('click',function(){
        var current=card._ngcCurrent;
        if(!current||!current.variant||!current.allocation)return;
        var key=String(current.variant.id)+':'+String(current.allocation.sellingPlanId);
        var existing=selections.get(key);
        if(existing){existing.quantity+=1;}
        else{
          selections.set(key,{
            key:key,
            handle:card.dataset.handle,
            dataKey:card.dataset.key,
            variantId:current.variant.id,
            sellingPlanId:current.allocation.sellingPlanId,
            title:current.data.title,
            image:current.data.image,
            options:optionSummary(current.data,current.variant),
            price:Number(current.allocation.price)||0,
            compareAtPrice:Number(current.allocation.compareAtPrice)||Number(current.allocation.price)||0,
            frequency:getFrequency(),
            quantity:1
          });
        }
        renderBox();
      });
    });

    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        var category=tab.dataset.ngcTab;
        tabs.forEach(function(button){button.setAttribute('aria-selected',button===tab?'true':'false');});
        cards.forEach(function(card){card.hidden=card.dataset.category!==category;});
      });
    });

    frequencyInputs.forEach(function(input){
      input.addEventListener('change',function(){
        syncSelectionsToFrequency();
        updateAllCards();
        renderBox();
      });
    });

    if(itemsNode)itemsNode.addEventListener('click',function(event){
      var button=event.target.closest('[data-qty-action]');
      if(!button)return;
      var row=button.closest('[data-summary-key]');
      if(!row)return;
      var item=selections.get(row.dataset.summaryKey);
      if(!item)return;
      if(button.dataset.qtyAction==='plus')item.quantity+=1;
      if(button.dataset.qtyAction==='minus')item.quantity-=1;
      if(item.quantity<=0)selections.delete(item.key);
      renderBox();
    });

    if(mobileReview)mobileReview.addEventListener('click',function(){
      if(!box)return;
      box.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      window.setTimeout(function(){box.focus({preventScroll:true});},350);
    });

    if(submit)submit.addEventListener('click',async function(){
      var values=Array.from(selections.values());
      if(!values.length)return;
      if(error)error.hidden=true;
      submit.disabled=true;
      submit.setAttribute('aria-busy','true');
      try{
        var response=await fetch(cartAddUrl,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',
          body:JSON.stringify({items:values.map(function(item){return {id:Number(item.variantId),quantity:item.quantity,selling_plan:Number(item.sellingPlanId)};})})
        });
        if(!response.ok)throw new Error('cart_add_failed');
        window.location.assign(cartUrl);
      }catch(e){
        if(error)error.hidden=false;
        submit.disabled=false;
        submit.removeAttribute('aria-busy');
      }
    });

    updateAllCards();
    renderBox();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
